import { css } from "@emotion/react";

export const inputContainerStyle = css`
  position: relative;
  width: 95%;
  max-width: 75vw;
  margin: 1rem auto 1.5rem auto;
  display: block;
  
  @media (max-width: 769px) {
    width: 95%;
    max-width: 95vw;
  }
`;

export const inputStyle = css({
  resize: "none",
  border: "2px solid #535353",
  borderRadius: "10px",
  width: "100%",
  padding: "10px",
  paddingRight: "120px", // Make space for the button
});

export const loadingContainer = css`
  text-align: center;
  min-height: 50vh;
  margin-top: 12vh;

  div {
    margin-top: 5vh;
  }
`;

// Base button style that will be shared across different button variants
export const baseButtonStyle = css`
  background: linear-gradient(135deg, rgb(46, 103, 141) 0%, rgb(72, 57, 125) 100%);
  border: 1px solid #8c8c8c;
  color: white;
  padding: 5px 22px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
    background: linear-gradient(135deg, #3a6f8c 0%, #5d5085 100%);
  }
  
  @media (max-width: 769px) {
    font-size: 14px;
    padding: 6px 16px;
  }
`;

// Button that's absolutely positioned on top of an input field
export const submitButtonStyle = css`
  ${baseButtonStyle}
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
`;

// Standard button that's positioned as a block element
export const standardButtonStyle = css`
  ${baseButtonStyle}
  margin: 15px auto;
  width: fit-content;
  
  @media (max-width: 769px) {
    width: 90%;
  }
`;

export const errorMsgStyle = css`
  font-weight: bold;
  font-size: 1.1rem;
  text-align: center;
  padding-top: 1rem;
`;

export const playlistLinksContainer = css`
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 20px;
  
  @media (max-width: 769px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const playlistLinkStyle = css`
  color: #d3d3d3;
  text-decoration: none;
  padding: 8px 16px;
  border: 1px solid #fff;
  border-radius: 6px;
  transition: all 0.3s ease;
  
  &:hover {
    text-decoration: none;
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
  }
`;

export const secondaryButtonStyle = css`
  margin: 15px auto;
  width: fit-content;
  background-color: transparent;
  color: #a0c4de;
  border: 1px solid rgba(160, 196, 222, 0.4);
  padding: 5px 22px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: none;
  
  &:hover {
    background-color: rgba(160, 196, 222, 0.1);
    border: 1px solid rgba(160, 196, 222, 0.8);
  }
  
  @media (max-width: 769px) {
    width: 90%;
    font-size: 14px;
    padding: 6px 16px;
  }
`;

export const dividerContainer = css`
  display: flex;
  align-items: center;
  margin: 20px auto;
  color: #8c8c8c;
  width: 75%;
  
  @media (max-width: 769px) {
    width: 100%;
  }
`;

export const dividerLine = css`
  flex: 1;
  height: 1px;
  background-color: #9e9d9d40;
`;

export const dividerText = css`
  padding: 0 16px;
  font-size: 14px;
`;

export const title = css`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0rem;
  margin-top: 1rem;
  padding: 1rem;
  color: white;

  @media (min-width: 770px) {
    width: 75%;
    margin: 0 auto;
  }}
`;